import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersistStoreService {

  constructor(private http: HttpClient) {
  }

  readStore(correlationId: string): Observable<any> {
    return this.http.get(this.prepareUrl(correlationId));
  }

  saveStore(correlationId: string, storeRootState: string): Observable<any> {
    return this.http.post(this.prepareUrl(correlationId), storeRootState);
  }

  private prepareUrl(correlationId: string): string {
    return `/sag/samoobsluga/${correlationId}/store`;
  }
}
